import toast from 'react-hot-toast';
import { useMutation } from 'react-query';

import { API_CTX } from '@/config';
import { queryClient } from '@/lib/react-query';
import { restoreURL } from '@/lib/axios';
import { filterOutFalsyValues } from '@/lib';

import { AI_QUERY_KEY, AIModulePayload } from '../types';

/**
 * Convert ai module payload to backend needed structure:
 */
const editAIModule = async ({ payload }: { payload: AIModulePayload }) => {
  const { id } = payload;
  if (!id) return console.warn(`## NO id to update AI module!`);
  const record = filterOutFalsyValues(payload);
  const data = {
    is_default: record['isDefault'],
    ai_module_key: payload.label,
    back_module_key: payload.moduleType,
    description: payload.description,
    status: payload.status,
    companies: payload.companies.map((c) => ({
      company_id: c.value,
      label: c.label,
    })),
  };
  await restoreURL().patch(`${API_CTX}/ai-modules/${id}`, data);
};

export const useEditAIModule = ({ onSuccess }: { onSuccess?: () => void }) => {
  return useMutation<void, Error, { payload: AIModulePayload }>(
    ({ payload }) => editAIModule({ payload }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(AI_QUERY_KEY);
        toast.success(`New AI module Updated successfully`);

        if (onSuccess) {
          onSuccess();
        }
      },
      onError: (error: Error) => {
        toast.error(`An error occurs: ${error.message}`);
      },
    }
  );
};
